import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'

const DEFAULT_SKILLS = [
    { id: '1', description: 'Strong foundation in CSS, HTML'},
    { id: '2', description: 'Strong JavaScript skills / jQuery'},
    { id: '3', description: 'Language Experience: PHP, Ruby, JavaScript / Node'},
    { id: '4', description: 'JavaScript frameworks: Angular, Vue, React, Ember'},
    { id: '5', description: 'Testing frameworks: Jest, Jasmine'},
    { id: '6', description: 'Database Experience: MySQL, MongoDB'},
    { id: '7', description: 'CMS Experience: Wordpress, OpenCart'},
    { id: '8', description: 'Version Control (Git)'},
    { id: '9', description: 'Adobe Photoshop/Illustrator'},
    { id: '10', description: 'Google Adwords and Google Analytics'},
];

const DEFAULT_TRAITS = [
    { id: '1', description: 'Passion for development, always looking to improve my web development skills'},
    { id: '2', description:'Great communication and collaboration skills'},
    { id: '3', description: 'High self-motivation in working individually and closely with other teams'},
    { id: '4', description: 'Doing research, market analysis and information structure'},
    { id: '5', description: 'Building user stories, personas, task flows, storyboards, sitemaps, use cases and scenarios'},
    { id: '6', description: 'Performing user testing'},
    { id: '7', description: 'Problem solving skills'},
    { id: '8', description: 'Providing development support'},
    { id: '9', description: 'Experience in responsive web design, cross-platform compatible coding techniques and troubleshooting'},
]

const DEFAULT_HOBBIES = [
    { id: '1', description: 'Passionate for martial arts and self development'},            
    { id: '2', description: 'Learning new things and always be in motion'},
    { id: '3', description:'Traveling and exploring new places'},
    { id: '4', description: 'Reading blogs, books and be engaged'},
    { id: '5', description: 'Listening to electronic music'},
]

const EXPERIENCE = [
    { id: '1', role: 'Software Engineer', company: 'Financial Cloud', tenure: 'August 2018 - Present'},
    { id: '2', role: 'Software Developer', company: 'Emergeadapt / Caseblocks', tenure: 'March 2017 - August 2018'},
    { id: '3', role: 'Developer', company: 'Castle Water', tenure: 'January 2016 - March 2017'},
    { id: '4', role: 'Web Developer', company: 'Artisan Hardwood Flooring', tenure: 'January 2016 - June 2017'},
]

const EDUCATION = [
    { id: '1', qualification: 'Honours’s degree (2:1) - Web and Mobile Development', location: 'University of the West of Scotland', tenure: '2014 - 2016'},
    { id: '2', qualification: 'HND - Interactive Media', location: 'Ayrshire College', tenure: '2012 - 2014'},
    { id: '3', qualification: '5 Highers', location: 'Barrhead High School', tenure: '2006 - 2012'},
]


class AboutPage extends React.Component {
    render() {
        const siteTitle = "Darren Hay - About Me - Portfolio"
        const siteDescription = "This is my portfolio about page, with information about me"

        return (
            <Layout>
                <Helmet>
                        <title>{siteTitle}</title>
                        <meta name="description" content={siteDescription} />
                </Helmet>

                <div id="main">

                    <section id="one">
                        <header className="major">
                            <h2>About Me</h2>
                        </header>
                        <p>
                        ​Currently I primarily use full stack JavaScript in most of my projects, 
                        most of my proffesional experience has also been primarily with JavaScript.<br/> <br/>
                        I like spending my time making small projects that allow me to develop my 
                        skills as I'm passionate about technology, science, mauy thai, traveling and constantly learning and experiencing new things.
                        </p>
                        
                        <div>
                            <h3>
                                SKILLS  
                            </h3>

                            <ul>
                                {DEFAULT_SKILLS.map(skill => <li>{skill.description}</li>)}
                            </ul>
                        </div>

                        <div>
                            <h3>
                                I HAVE
                            </h3>

                            <ul>
                                {DEFAULT_TRAITS.map(trait => <li>{trait.description}</li>)}
                            </ul>
                        </div>

                        <div>
                            <h3>
                                I LOVE  
                            </h3>

                            <ul>
                                {DEFAULT_HOBBIES.map(hobby => <li>{hobby.description}</li>)}
                            </ul>
                        </div>

                        <div>
                            <h3>
                                EXPERIENCES  
                            </h3>

                            {EXPERIENCE.map(job => <div>
                                <h4>{job.company}</h4>
                                <p>{job.role}<br/>
                                {job.tenure}</p>
                            </div>)}        
                        </div>

                        <div>
                            <h3>
                                EDUCATION  
                            </h3>

                            {EDUCATION.map(education => <div>
                                <h4>{education.qualification}</h4>
                                <p>{education.location}<br/>
                                {education.tenure}</p>
                            </div>)}
                        </div>

                        <ul className="actions">
                            <li><a href="/" className="button">Home</a></li>
                        </ul>
                    </section>

                </div>

            </Layout>
        )
    }
}

export default AboutPage